import * as React from "react";

import { down_svg } from "./language-control-elements";

const LanguageControl: React.FC = (props) => {
  return (
    <div className={`m-language-control`}>
      <p>ES</p>
    </div>
  );
};

export default LanguageControl;
